import React from 'react'
import styles from '../styles.module.css'
import { useSelector } from 'react-redux';
import moment from 'moment'

const Table = ({ data, reportParams }) => {
  
  const { year, idOrg } = reportParams
  
  const orgList = useSelector(state => state.reports.orgList.data)

  const org = orgList ? orgList.find(org => org.idOrganization == idOrg) : {}

  if (!data) return null;
  
  const renderRow = (event, index) => {
    const date = moment(event.event_date, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY')
    const length = event.members.length
    if (length) return (
      <>
        {event.members.map((mem, ind) => {
          return (
          <tr>
            <td>{index + ind + 1}</td>
            <td>{date}</td>
            <td>{event.vuz}</td>
            <td>{event.representative}</td>
            <td>{event.event}</td>
            <td>{event.forma_provedeniya}</td>
            <td>{`${mem.fio} ${mem.speciality}`}</td>
          </tr>
          )
          }
        )}
      </>
    )
    else {
      return (
      <tr>
        <td>{index + 1}</td>
        <td>{date}</td>
        <td>{event.vuz}</td>
        <td>{event.representative}</td>
        <td>{event.event}</td>
        <td>{event.forma_provedeniya}</td>
        <td></td>
      </tr>
    )}
  }

  return (
    <div className={styles.tableBlock}>
      {data.map(el => {
      let x = 0;
      return (
          <React.Fragment key={el[0].idorganization}>

        <h3 className={"text-center mb-2 mt-5"}>Сведения о проведенных мероприятиях военно-профессиональной ориентации выпускников</h3>
              <h3 className={"text-center mb-2"}>{el[0].school_ref}</h3>
              <h3 className={"text-center mb-2"}>{`на поступление в высшие военно-учебные заведения в ${year} году`}</h3>
        <table id={`graduatesTable_${el[0].idorganization}`} className={styles.mainTable}>
        <thead>
          <tr>
            <th>№ п/п</th>
            <th>Дата проведения мероприятия</th>
            <th>Наименование высшего военно-учебного заведения (органа военного управления), проводившего мероприятие</th>
            <th>Воинское звание, фамилия, имя, отчество и должность лица, проводившего мероприятие</th>
            <th>Проведенное мероприятие</th>
            <th>Форма проведения</th>
            <th>Фамилия, имя, отчество выпускников, изъявивших желание поступать в высшее военно-учебное заведение и наименование специальности</th>
          </tr>
        </thead>
            <tbody>
            {el.map((student, index) => {
              x = x + (student.members.length || 1)
              return renderRow(student, x - (student.members.length || 1))
            })}
            </tbody>
            </table>
          </React.Fragment>
        )}
        )}
    </div>
  )
}

export default Table
